'use strict';

import axios from 'axios';
import * as dom from './lib/dom.js';
import * as dfp from '../dfp-load-show.js';

let loadingMoreNews = false;
let lastUrl = false;
let newUrl = false;

const loadMoreNews = () => {
    const bodyHeight = document.querySelector('body').offsetHeight;
    const header = document.querySelector('.c-header');
    const headerHeight = header.offsetHeight;
    const targetHtml = document.querySelector('.js-load-more-content');
    const urlEl = targetHtml.querySelector('.js-load-more-params');
    const spinner = document.querySelector('.c-load-more-content-spinner');
    const targetHtmlChild = document.createElement('div');

    if (urlEl) {
        let url = urlEl.getAttribute('data-url') + '&is_ajax=true';
        

        if (window.pageYOffset > (bodyHeight - headerHeight) * 0.30 && loadingMoreNews === false) {
            console.log(url);
            loadingMoreNews = true;
            spinner.style.display = 'block';
            axios
                .get(url)
                .then(function (response) {
                    let historyUrl = url.replace(/[\?\&](is_ajax\=.*)/gi, '');
                    historyUrl = url.replace(/[\?\&](home\=.*)/gi, '');
                    if (lastUrl === false) {
                        lastUrl = window.location.href;
                    }

                    newUrl = historyUrl;

                    // window.history.pushState('', '', historyUrl);

                    urlEl.parentNode.removeChild(urlEl);
                    targetHtmlChild.innerHTML = response.data;
                    targetHtml.appendChild(targetHtmlChild);
                    spinner.style.display = 'none';
                    loadingMoreNews = false;
                    // console.log('loaded more news');

                    const adDivs = targetHtml.querySelectorAll('.js-dfp-container');
                    dfp.initializeSlots(adDivs);

                    const categoryLinks = targetHtml.querySelectorAll('.js-category-link');
                    if (categoryLinks.length > 0) {
                        dom.forEachEl(categoryLinks, (el) => {
                            el.addEventListener('click', (e)=>{
                                e.preventDefault();
                                const url = el.getAttribute('data-url');
                                window.location.href = url;
                            });
                            el.addEventListener('auxclick', function(e) {
                                if (e.button == 1) {
                                    e.preventDefault();
                                    const el = e.target;
                                    const url = el.getAttribute('data-url');
                                    window.open(url, "_blank");
                                }
                            });
                            
                            const elParent = dom.parents(el, 'c-post-card__link');
                            el.addEventListener('mouseenter', function(e) {
                                dom.addClass(elParent, 'c-post-card--not-hover')
                            });
                
                            el.addEventListener('mouseleave', function(e) {
                                dom.removeClass(elParent, 'c-post-card--not-hover')
                            })
                        });
                    }

                    

                    // console.log(adDivs);

                })
                .catch(function (error) {
                    console.log('error', error);
                });
        }
    }
}

const restoreUrl = () => {
    const loadedContentEl = document.querySelector('.c-load-more-content-1');
    let loadedContentElOffset = loadedContentEl.offsetTop;
    let scrollObject;
    scrollObject = window.pageYOffset;

    if (lastUrl !== false) {
        if (scrollObject < loadedContentElOffset) {
            window.history.pushState('', '', lastUrl);
        } else {
            window.history.pushState('', '',newUrl);
        }
    }
}

export default function() {
    const is_home = document.querySelector('.home');
    if(is_home){
        // window.addEventListener('scroll', function() {
        //     restoreUrl();
        // });

        window.addEventListener('resize', function() {
            loadMoreNews();
        });

        window.addEventListener('scroll', function() {
            loadMoreNews();
        });
    }
        
}

